<app-base-modal modalSize="sm-md"
                id="calc_max_content_modal_result">
    <ng-template>
        <div id="calc_max_content_modal"
             class="result-modal">
            <div class="content-container">
                <div class="icon-container">
                    <app-modal-icons [iconType]="modalActions.iconType"></app-modal-icons>
                </div>
                <div class="title-container">
                    <label id="calc_max_content_modal_title"
                           class="title-text">{{modalActions.title}}</label>
                </div>
                <div class="result-description"
                     [innerHTML]="modalActions.description">
                </div>
                <div class="buttons-container">
                    <button id="calc_max_content_modal_close_button"
                            name="calc-max-content-modal-close-button"
                            type="submit"
                            (click)="onBtnClick()"
                            class="app-submit-btn">
                        <svg width="16"
                             height="16"
                             viewBox="0 0 16 16"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg"
                             class="mb-2">
                            <path fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M10.5511 14.6667C10.2638 14.6667 9.97764 14.5504 9.76875 14.3214L4.6551 8.71295C4.28684 8.30904 4.28684 7.69105 4.6551 7.28713L9.76875 1.67866C10.1625 1.24681 10.8319 1.21581 11.2637 1.60956C11.6955 2.00343 11.7264 2.67263 11.3328 3.10448L6.86906 8.00004L11.3328 12.8956C11.7264 13.3274 11.6955 13.9967 11.2637 14.3905C11.0608 14.5755 10.8055 14.6667 10.5511 14.6667Z"
                                  fill="#fff" />
                        </svg>
                        {{modalActions.cancelText}}
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</app-base-modal>